interface CountsPayload {
    counts: Record<string, Record<string, number>>;
    totals: Record<string, number>;
    siteTotal: { reviews: number; locales: number };
}

class FacetNavCounts {
    init() {
        const navs = document.querySelectorAll<HTMLElement>(".facet-nav[data-locale]");
        const siteTotalEl = document.querySelector<HTMLElement>("[data-site-total]");
        if (!navs.length && !siteTotalEl) {
            return;
        }

        fetch("/index.json")
            .then((response) => response.json())
            .then((payload: CountsPayload) => {
                navs.forEach((nav) => this.render(nav, payload));
                if (siteTotalEl) {
                    this.renderSiteTotal(siteTotalEl, payload);
                }
            })
            .catch(() => {
                // Fetch/parse failure: leave the badges/spacer blank rather
                // than throw — the links themselves still work.
            });
    }

    private render(nav: HTMLElement, payload: CountsPayload) {
        const locale = nav.dataset.locale || "";
        const counts = payload?.counts?.[locale] || {};

        nav.querySelectorAll<HTMLElement>(".n[data-count-key]").forEach((el) => {
            const key = el.dataset.countKey || "";
            const count = counts[key];
            if (count !== undefined) {
                el.textContent = String(count);
            }
        });

        const spacer = nav.querySelector<HTMLElement>(".facet-nav-spacer[data-locale-total]");
        if (spacer) {
            const total = payload?.totals?.[locale];
            const localeDisplay = spacer.dataset.localeDisplay || "";
            if (total !== undefined) {
                spacer.textContent = `${total} reviews in ${localeDisplay}`;
            }
        }
    }

    private renderSiteTotal(el: HTMLElement, payload: CountsPayload) {
        const siteTotal = payload?.siteTotal;
        if (siteTotal?.locales !== undefined) {
            el.textContent = `${siteTotal.reviews} reviews · ${siteTotal.locales} locales`;
        }
    }
}

export default new FacetNavCounts();
